import imgElsaHigareda from "assets/img/25/Elsa Higareda.jpg";
import imgBlancaMejia from "assets/img/25/Blanca Mejía 2.jpg";
import imgBonnieGonzales from "assets/img/25/Bonnie Gonzales.jpg";
import imgDavidBruner from "assets/img/25/David Bruner 2.jpg";

export default [
  {
    name: "Elsa Higareda",
    description: {
      es:
        "Mi nombre es Elsa Higareda soy de Cojumatlán, Michoacán, y esta es mi primera vez participando. Ha sido una experiencia única, rodeada de este paraíso junto a la laguna de Chapala. El lugar, el hotel, las personas… todo ha sido extraordinario. Invito con el corazón a quienes viven en Cojumatlán y en Los Ángeles a que se integren a Ciencia de la Mente. Esta filosofía transforma vidas. A mí ya me la cambió.",
      en:
        "My name is Elsa Higareda, I'm from Cojumatlán, Michoacán, and this is my first time participating. It has been a unique experience, surrounded by this paradise next to Lake Chapala. The place, the hotel, the people—everything has been extraordinary. I wholeheartedly invite those living in Cojumatlán and Los Angeles to join Science of Mind. This philosophy transforms lives. It has already changed mine.",
    },
    img: imgElsaHigareda,
    url: "https://youtu.be/vGIi0i9gaBo",
  },
  {
    name: "Bonnie González",
    description: {
      es:
        "Esta convención en Chapala ha sido una experiencia inspiradora, llena de conexión y alma. Me sentí honrada de ser parte. Te invito a vivirlo tú también.",
      en:
        "This convention in Chapala has been an inspiring experience, full of connection and heart. I was honored to be part of it. I invite you to come and experience it for yourself.",
    },
    img: imgBonnieGonzales,
    url: "https://youtu.be/4X_2dNIdwGE ",
  },
  {
    name: "Blanca Mejía",
    description: {
      es:
        "Desde que viví mi primera convención en 2015, supe que era algo especial. Estar aquí en Chapala, compartiendo en persona, es simplemente mágico. Esta comunidad crece con amor. ¡Tienes que vivirlo!",
      en:
        "Ever since my first convention in 2015, I knew this was something special. Being here in Chapala, connecting in person, is simply magical. This community grows with love. You have to experience it!",
    },
    img: imgBlancaMejia,
    url: "https://youtu.be/QF9ZyK3rhs0",
  },
  {
    name: "Rev. Dr David Bruner",
    description: {
      es:
        "He venido a esta convención muchas veces, y sigo regresando por la gente y por la ubicación. Mi alma se siente en casa aquí. Ser parte de esta comunidad de Ciencia de la Mente es una alegría, y cada visita es una experiencia única y poderosa.",
      en:
        "I've come to this convention many times, and I keep returning because of the people—and the location. My soul feels at home here. Being part of this Science of Mind community is a joy, and every visit is a unique and powerful experience.",
    },
    img: imgDavidBruner,
    url: "https://youtu.be/qOBfbp9Ooo8",
  },
];
